var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"esg"},[_c(_setup.EsgRating,{attrs:{"esg-data":_setup.esg.data?.data || [],"rating-config":_setup.ratingConfig,"loading":_setup.loading}}),(_setup.reportList.length)?_c(_setup.EsgReport,{attrs:{"report-list":_setup.reportList}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }